import React from 'react';
import * as PropTypes from 'prop-types';
import { DialogContent, DialogTitle } from '@material-ui/core';
import Dialog from '../../dialogs/components/Dialog';
import { useCallbackRef } from '../../hooks';
import DialogFormActions from '../../dialogs/components/DialogFormActions';
import RejectCustomerForm from './RejectCustomerForm';
import { IdPropType } from '../../../proptypes/basic';

const RejectCustomerDialog = ({ onClose, customerId }) => {
    const ref = useCallbackRef();

    return (
        <Dialog fullWidth maxWidth="xs">
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Interessent nicht geeignet</DialogTitle>

            <DialogContent>
                <RejectCustomerForm submitRef={ref} customerId={customerId} onDone={onClose} />
            </DialogContent>

            <DialogFormActions ref={ref} />
        </Dialog>
    );
};

RejectCustomerDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    customerId: IdPropType.isRequired,
};

RejectCustomerDialog.defaultProps = {};

export default RejectCustomerDialog;
